import ModelSelection from './ModelSelection'
import modelSelectionContainer from './modelSelectionContainer'

export default modelSelectionContainer(ModelSelection)
